import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyLoanDetails from "./component";
import { diyPaymentApprovalProcess, setActiveTab, submitLoanDetails } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        postTokenDocuments,
        loanDetails
    }
}) => ({
    inspectionResponse,
    postTokenDocuments,
    loanDetails
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    diyPaymentApprovalProcessConnect: diyPaymentApprovalProcess,
    submitLoanDetailsConnect: submitLoanDetails,
    setActiveTabConnect: setActiveTab
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyLoanDetails);
